import styled from "@emotion/styled";

import { fontSourceSerif4 } from "shared/lib/styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  inline-size: 100%;
  border-block-start: 1px #000000 solid;

  padding-block-start: 12px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Title = styled.div`
  flex-shrink: 0;

  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
  white-space: nowrap;

  a {
    color: #000000;
    text-decoration: none;
  }
`;
